import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import DeliveryOptions from './deliveryOptions';

const DeliveryOptionsWrapper = ({ summary, descriptionContent, descriptionTitle }) => {
  const cmsDeliveryOptions = {
    summary,
    descriptionContent,
    descriptionTitle,
  };

  return cmsDeliveryOptions.summary ? (
    <DeliveryOptions customClass="pdp-content" cmsMessage={cmsDeliveryOptions} />
  ) : null;
};

DeliveryOptionsWrapper.propTypes = {
  summary: PropTypes.string.isRequired,
  descriptionTitle: PropTypes.string.isRequired,
  descriptionContent: PropTypes.string.isRequired,
};

const mapStateToProps = ({ detailsPage }) => ({
  summary: detailsPage.loadedProduct.contentSlotsJson.deliveryReturn
    ? detailsPage.loadedProduct.contentSlotsJson.deliveryReturn.components[0].content
    : '',
  descriptionContent: detailsPage.loadedProduct.contentSlotsJson.deliveryReturn
    ? detailsPage.loadedProduct.contentSlotsJson.deliveryReturn.components[0].details.content
    : '',
  descriptionTitle: detailsPage.loadedProduct.contentSlotsJson.deliveryReturn
    ? detailsPage.loadedProduct.contentSlotsJson.deliveryReturn.components[0].details.title
    : '',
});

export default connect(mapStateToProps)(DeliveryOptionsWrapper);
